<div class="page-not-found">
    <div class="container">
        <div class="center">
            Looks like we lost this link...<fa-icon [icon]="faSadTear"></fa-icon>
            <span>Please try a different link or <a href="/jobs">click here to view jobs</a></span>
        </div>
    </div>
</div>